import type { RawReadUserProfileResponse } from '@heviton/heviton-api-app-legacy';
import type { User } from '@/shared/data-types';

/**
 * BE `RawReadUserProfileResponse` → FE `User` (flat). **순수 변환** — 검증·throw 없음.
 *
 * wire 타입이 `account?`/`profile?` 까지 nullable 인 permissive shape 이지만 BE 계약상
 * `account.loginId` 와 `profile.name` 은 항상 제공된다는 전제. 그럼에도 throw 대신 빈 문자열로
 * graceful 격하 — UI 가 비어 보이는 게 에러 화면보다 항상 낫다는 정책 (BE 응답 invariant
 * 검증은 일부러 안 함, ADR `domain-ssot` §5 참조).
 */
export function fromRawUser(raw: RawReadUserProfileResponse): User {
  return {
    userId: raw.account?.loginId ?? '',
    accountKey: raw.profile?.accountKey ?? '',
    userAccountId: raw.account?.accountId ?? undefined,
    userName: raw.profile?.name ?? '',
    birthday: raw.profile?.birthday ?? undefined,
    userContactNumber: raw.profile?.mobile ?? undefined,
    userEmail: raw.profile?.email ?? undefined,
  };
}
